import NewFooter from '../NewFooter/NewFooter';
import ProjectLogo from '../ProjectLogo/ProjectLogo';
import { EegLandingPageFooterProps } from './types';

const EegFooter = ({ skewOverlap }: EegLandingPageFooterProps) => {
  return (
    <NewFooter
      copyrightText="enercity Erneuerbare GmbH"
      foundationSlot={
        <>
          <NewFooter.Link href="/impressum">Impressum</NewFooter.Link>
          <NewFooter.Link href="/datenschutz">Datenschutz</NewFooter.Link>
        </>
      }
      logoSlot={<ProjectLogo height={54} project="eeg" solidFill />}
      skewOverlap={skewOverlap}
    />
  );
};

export default EegFooter;
